import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import { withDefault } from "../../utils/withDefault";

type AppTextButtonColor = "black" | "white" | "green" | "primary";
type AppTextButtonVariation = "block" | "inline";

interface Props
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color: AppTextButtonColor;
  variation?: AppTextButtonVariation;
  disabled?: boolean;
}

export function AppTextButton(props: PropsWithChildren<Props>): ReactElement {
  const { variation: _variation, color, ...rest } = props;
  const variation: AppTextButtonVariation = withDefault(props.variation, "inline");

  return (
    <button
      {...rest}
      className={classNames("AppTextButton", rest.className)}
      data-variation={variation}
      data-color={props.color}
    >
      {props.children}
    </button>
  );
}
